import { __assign } from "tslib";
import React from 'react';
import ImageDumbo from '../../../../DeviationViews/Dumbo/Image';
/**
 *
 * IMPORTANT!
 * Currently to support green/mobile we are using inline
 * styles to render editor related content. Do NOT add
 * classes to anything here for now.
 */
var ImageDumbView = function (props) {
    return (React.createElement(ImageDumbo, __assign({}, props, { className: "daeditor-thumb-image", extraWrapStyles: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
        } })));
};
ImageDumbView.displayName = 'ImageDumbView';
export default ImageDumbView;
//# sourceMappingURL=ImageHtml.js.map